import React from 'react';

import { ContinueButton } from './ContinueButton';
import { EmailInput } from './EmailInput';
import { PasswordInput } from './PasswordInput';

interface EmailLoginFormProps {
  email: string;
  password: string;
  step: 'email' | 'password';
  error: string | null | undefined;
  isLoading: boolean;
  onEmailChange: (value: string) => void;
  onPasswordChange: (value: string) => void;
  onSubmit: (e?: React.FormEvent) => void;
  onBackToEmail: () => void;
  onForgotPassword: () => void;
}

const EmailPasswordInputs: React.FC<{
  email: string;
  password: string;
  step: 'email' | 'password';
  isLoading: boolean;
  onEmailChange: (value: string) => void;
  onPasswordChange: (value: string) => void;
}> = ({ email, password, step, isLoading, onEmailChange, onPasswordChange }) => (
  <>
    <EmailInput value={email} onChange={onEmailChange} disabled={isLoading || step === 'password'} readOnly={step === 'password'} />
    {step === 'password' && <PasswordInput value={password} onChange={onPasswordChange} disabled={isLoading} placeholder="Password" autoFocus />}
  </>
);

const AuthLinks: React.FC<{ step: 'email' | 'password'; onBackToEmail: () => void; onForgotPassword: () => void }> = ({ step, onBackToEmail, onForgotPassword }) => (
  step === 'password' ? (
    <div className="auth-links">
      <button type="button" className="forgot-back-link" onClick={onBackToEmail}>← Back</button>
      <button type="button" className="forgot-password-link" onClick={onForgotPassword}>Forgot password?</button>
    </div>
  ) : (
    <button type="button" className="forgot-password-link" onClick={onForgotPassword}>Forgot password?</button>
  )
);

export const EmailLoginForm: React.FC<EmailLoginFormProps> = (props) => (
  <form className="email-section" onSubmit={props.onSubmit}>
    <EmailPasswordInputs
      email={props.email}
      password={props.password}
      step={props.step}
      isLoading={props.isLoading}
      onEmailChange={props.onEmailChange}
      onPasswordChange={props.onPasswordChange}
    />
    {props.error && <p className="auth-error-text">{props.error}</p>}
    <ContinueButton
      onClick={() => props.onSubmit()}
      isLoading={props.isLoading}
      disabled={props.step === 'email' ? !props.email.trim() : !props.password.trim()}
    >
      {props.step === 'email' ? 'Continue' : 'Sign In'}
    </ContinueButton>
    <AuthLinks step={props.step} onBackToEmail={props.onBackToEmail} onForgotPassword={props.onForgotPassword} />
  </form>
);
